import React, { Component } from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {networkResetDeviceActions} from "../../../actions/network-reset-device.actions";
import {Spinner} from "react-bootstrap";
import {Link} from "react-router-dom";
import NetworkResetDeviceForm from "./_form/NetworkResetDeviceForm";

class NetworkResetDeviceEditPage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        const id = this.props.match.params.id;
        dispatch(networkResetDeviceActions.getNetworkResetDeviceById(id));
    }

    render() {
        const { t, singleItem } = this.props;

        const breadcrumb = [
            { value: 'network-reset-device', path: '/panel/network-reset-device' },
            { value: 'edit_network-reset-device', path: '#' }
        ];
        return (
            <div>
                { singleItem ? (
                    <React.Fragment>
                        <BreadcrumbExtend items={breadcrumb} />
                        <h4>{t('edit_network-reset-device')}</h4>
                        <h5 className="font-italic">{  singleItem?.resetator?.label }</h5>
                        <div className="card">
                            <div className="card-header">
                                <div className="button-group">
                                    <Link to="/panel/network-reset-device" className="btn btn-secondary float-right btn-create">
                                        <i className="fas fa-undo"> </i> &nbsp; { t('back-to-list') }
                                    </Link>
                                </div>
                            </div>
                            <div className="card-body">
                                <NetworkResetDeviceForm data={singleItem} />
                            </div>
                        </div>
                    </React.Fragment>
                ) : (<Spinner animation={"border"} />)}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { singleItem } = state.networkResetDeviceReducer;
    return {
        singleItem
    }
}
export default withNamespaces()(connect(mapStateToProps)(NetworkResetDeviceEditPage));
